/* de-app.js — Digit Exclusive 2.0 client-side enhancements
   - Sticky header shadow on scroll
   - Reveal-on-scroll animations
   - Mobile sticky CTA visibility (PDP)
   - Lazy-load audit (loading="lazy" for below-fold images)
   - Smooth in-page anchor scrolling
   ES6+, no dependencies, ~3 KB minified.
*/
(function () {
  'use strict';

  // 1. Header scroll shadow
  document.addEventListener('DOMContentLoaded', function () {
    var header = document.querySelector('.de-header');
    if (!header) return;
    var lastScroll = 0;
    var update = function () {
      var y = window.scrollY;
      if (y > 8 && lastScroll <= 8) header.classList.add('is-scrolled');
      else if (y <= 8 && lastScroll > 8) header.classList.remove('is-scrolled');
      lastScroll = y;
    };
    window.addEventListener('scroll', update, { passive: true });
    update();
  });

  // 2. Reveal-on-scroll
  if ('IntersectionObserver' in window) {
    document.addEventListener('DOMContentLoaded', function () {
      var revealObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            revealObs.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
      document.querySelectorAll('.reveal').forEach(function (el) {
        revealObs.observe(el);
      });
      // Safety net: force-reveal anything still hidden after 3s
      setTimeout(function () {
        document.querySelectorAll('.reveal:not(.is-visible)').forEach(function (el) {
          el.classList.add('is-visible');
        });
      }, 3000);
    });
  } else {
    // No-IO fallback: reveal everything immediately
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('.reveal').forEach(function (el) {
        el.classList.add('is-visible');
      });
    });
  }

  // 3. Mobile sticky CTA visibility (PDP only)
  document.addEventListener('DOMContentLoaded', function () {
    var sticky = document.querySelector('.de-sticky-cta');
    if (!sticky) return;
    var trigger = document.querySelector('.de-pdp__buy') ||
                  document.querySelector('[data-de-buy-button]') ||
                  document.querySelector('button[name="add"]');
    if (!trigger || !('IntersectionObserver' in window)) {
      sticky.classList.add('is-visible');
      sticky.setAttribute('aria-hidden', 'false');
      return;
    }
    var ctaObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var show = e.intersectionRatio === 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      });
    }, { threshold: [0] });
    ctaObs.observe(trigger);
  });

  // 4. (removed) legacy sticky->add mis-wiring — the de-polish.js data-de-buy
  //    interceptor owns the sticky Buy anchor (cart-preserving checkout).

  // 5. Lazy-load audit
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('img:not([loading])').forEach(function (img) {
      var rect = img.getBoundingClientRect();
      if (rect.top > window.innerHeight * 0.8) {
        img.setAttribute('loading', 'lazy');
        img.setAttribute('decoding', 'async');
      }
    });
  });

  // 6. Smooth anchor scroll
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href^="#"]');
    if (!link) return;
    var href = link.getAttribute('href');
    if (href === '#' || href === '#main') return;
    var target = document.querySelector(href);
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  // 7. Mobile menu toggle
  document.addEventListener('DOMContentLoaded', function () {
    var toggle = document.querySelector('.de-header__menu-toggle');
    var nav = document.querySelector('.de-header__nav');
    if (!toggle || !nav) return;
    toggle.addEventListener('click', function () {
      var isOpen = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen);
    });
  });
})();
